import initialState from 'redux/initial-states/dashboard';
import cardOperationFeesReducer from './cardOperationFees';
import addMoneyFromCreditCardReducer from './addMoneyFromCreditCard';
import addMoneyFromPayPal from './addMoneyFromPayPal';
import payPalOperationFees from './payPalOperationFees';
import gatewayAddMoneyFees from './gatewayAddMoneyFees';
import addMoneyWithMobileOperator from './addMoneyWithMobileOperator';

export default (state = initialState, action = {}) => ({
  ...state,
  ...addMoneyFromCreditCardReducer(state, action),
  ...cardOperationFeesReducer(state, action),
  ...addMoneyFromPayPal(state, action),
  ...payPalOperationFees(state, action),
  ...gatewayAddMoneyFees(state, action),
  ...addMoneyWithMobileOperator(state, action),
});
